
import styled from 'styled-components/macro'
import { useDispatch } from 'react-redux'
import { setFilter } from '../../redux/slices/categories'
import { useTranslation } from 'react-i18next'


const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #E9E5E2;
    border-radius: 10px;
    height: 100%;

    @media (max-width: 577px) {
        display: none;
    }
`

const Item = styled.div`
    font-family: 'Montserrat';
    font-size: 18px;
    padding: 25px 60px;
    background: ${props => props.isActive && '#EDE8E8'};
    cursor: pointer;
    text-transform: capitalize;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
`



const VerticalFilters = ({items, currentFIlter}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation()
    

    const filterSubmitHandler = (value) => {
        dispatch(setFilter({
            ...currentFIlter,
            subcathegory: value
        }));
    }

  return (
      <Root>
        <Item onClick={() => filterSubmitHandler('')} isActive={!currentFIlter.subcathegory}>
            {t('all')}
        </Item>
        {items.map((item) => (
            <Item onClick={() => filterSubmitHandler(item)} isActive={currentFIlter.subcathegory === item}>
                {t(item)}
            </Item>
        ))}
      </Root>
  )
}

export default VerticalFilters